function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { ReactComponent as AduitSvg } from "../../assets/svg/aduit.svg";
import { ReactComponent as ExportSvg } from "../../assets/svg/export.svg";
import { ReactComponent as BackSvg } from "../../assets/svg/icon-back.svg";
import { ReactComponent as RejectSvg } from "../../assets/svg/reject.svg";
import { ReactComponent as RefuseSvg } from "../../assets/svg/refuse.svg";
import { ReactComponent as SaveSvg } from "../../assets/svg/save.svg";
import { ReactComponent as RefreshSvg } from "../../assets/svg/refresh.svg";
import DatePicker from "../../components/DatePicker";
import Form from "../../components/Form/Form";
import { AutoFillSuggest, DictSuggest } from "../../components/Form/Suggest";
import { DictText, Text } from "../../components/Form/Text";
import { UploadWithFilename } from "../../components/Form/Upload";
import HtmlText from "../../components/HtmlText";
import { ExclamationCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Input, Modal, Spin, Table, Tooltip } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { Link, useSearchParams } from 'react-router-dom';
import { useTaskDetailDrawer } from "../../pages/taskList/components/TaskDetail";
import TreeSelect from "./TreeSelect";
import styles from "./index.module.css";
import { useDetail } from "./state";
import classnames from 'classnames';
import dayjs from 'dayjs';
import { nanoid } from 'nanoid';
import { useEffect, useState } from 'react';
import PureTable from "./PureTable";
import Search from "./Search";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Detail = function Detail() {
  var _data$orderFlowList;
  var _useDetail = useDetail(),
    _useDetail$data = _useDetail.data,
    category = _useDetail$data.category,
    activeCategory = _useDetail$data.activeCategory,
    ref = _useDetail$data.ref,
    data = _useDetail$data.data,
    loading = _useDetail$data.loading,
    renderKey = _useDetail$data.renderKey,
    detailCol = _useDetail$data.detailCol,
    expanded = _useDetail$data.expanded,
    renderDetails = _useDetail$data.renderDetails,
    numberMap = _useDetail$data.numberMap,
    _useDetail$action = _useDetail.action,
    onSkuListQuery = _useDetail$action.onSkuListQuery,
    onSave = _useDetail$action.onSave,
    onRefresh = _useDetail$action.onRefresh,
    onSubmit = _useDetail$action.onSubmit,
    onExport = _useDetail$action.onExport,
    onReject = _useDetail$action.onReject,
    setDetails = _useDetail$action.setDetails,
    setRenderDetails = _useDetail$action.setRenderDetails,
    onResetSearch = _useDetail$action.onResetSearch,
    onSelectCategory = _useDetail$action.onSelectCategory,
    onSearchDetail = _useDetail$action.onSearchDetail,
    setExpanded = _useDetail$action.setExpanded,
    setRenderKey = _useDetail$action.setRenderKey;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasStore = _useState2[0],
    setHasStore = _useState2[1];
  useEffect(function () {
    if (data && data.orgCode) {
      setHasStore(true);
    } else {
      setHasStore(false);
    }
  }, [data]);
  var openTaskDetailDrawer = useTaskDetailDrawer();
  var listCol = [{
    title: '任务编码',
    dataIndex: 'flowOrderCode',
    render: function render(v) {
      return /*#__PURE__*/_jsx(Link, {
        to: "/Task?flowOrderId=".concat(v),
        onClick: function onClick(e) {
          e.preventDefault();
          console.log('flowOrderCode ===>');
          openTaskDetailDrawer({
            flowOrderId: v
          }).catch(function (e) {
            console.log(e, 'e =>');
          });
        },
        target: "_blank",
        children: v
      });
    }
  }, {
    title: '任务名称',
    dataIndex: 'flowName'
  }, {
    title: '处理时间',
    dataIndex: 'finishTime'
  }, {
    title: '当前节点',
    dataIndex: 'currentNodeName'
  }, {
    title: '处理人',
    dataIndex: 'currentHandler',
    render: function render() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return value.map(function (e) {
        return "".concat(e.name, "\uFF08").concat(e.code, "\uFF09");
      }).join('、');
    }
  }, {
    title: '状态',
    dataIndex: 'flowStatus',
    render: function render(v) {
      return /*#__PURE__*/_jsx(DictText, {
        dictType: "scm_flow_state",
        value: v
      });
    }
  }, {
    title: '备注',
    dataIndex: 'reason'
  }];
  return /*#__PURE__*/_jsx(Spin, {
    spinning: loading,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.layout,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.header,
          children: [/*#__PURE__*/_jsx(BackSvg, {
            onClick: function onClick() {
              return window.close();
            }
          }), data.canEdit ? data.orderStatus === 'wait_submit' ? '编辑' : '新建' : '查看', "\u91C7\u8D2D\u7533\u8BF7\u5355", /*#__PURE__*/_jsx("div", {
            className: data.orderStatus ? styles[data.orderStatus] : undefined,
            children: /*#__PURE__*/_jsx(DictText, {
              value: data.orderStatus,
              dictType: "scm_request_order_status"
            })
          })]
        }), /*#__PURE__*/_jsxs(Form, {
          className: classnames(styles.form, data.canEdit ? null : styles.readonly),
          initialValues: {
            requestType: 'beforeOpening' // 默认值，开业前申请
          },
          ref: ref,
          mode: data.canEdit ? 'edit' : 'view',
          labelCol: {
            className: styles.label
          },
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.baseForm,
            children: [/*#__PURE__*/_jsxs(Form.Field, {
              name: "orgName",
              label: "\u8BA2\u8D27\u95E8\u5E97",
              required: true,
              rules: [{
                required: true,
                message: '请选择订货门店'
              }],
              children: [/*#__PURE__*/_jsx(AutoFillSuggest, {
                url: "/erp/scm/request/getOrgList",
                placeholder: "\u8BF7\u8F93\u5165\u8BA2\u8D27\u95E8\u5E97",
                className: styles.baseFormWidth,
                requestFilter: function requestFilter(_ref) {
                  var keyword = _ref.keyword;
                  return {
                    page: {
                      index: 1,
                      size: 10,
                      sorts: []
                    },
                    key: keyword
                  };
                },
                fillFields: [['orgName', 'label'], ['orgCode', 'value'], ['address', 'address'], ['contract', 'userName'], ['phone', 'phone']],
                onSelect: function onSelect(orgCode) {
                  return onSkuListQuery({
                    orgCode: orgCode
                  });
                },
                onClear: function onClear() {
                  var modal = Modal.confirm({
                    className: styles.modal,
                    title: "\u786E\u8BA4\u6E05\u9664\u95E8\u5E97\u5417?",
                    content: /*#__PURE__*/_jsx("span", {
                      style: {
                        color: '#6E707A'
                      },
                      children: "\u6E05\u9664\u540E\u586B\u5199\u7684\u4FE1\u606F\u5C06\u88AB\u6E05\u7A7A"
                    }),
                    icon: /*#__PURE__*/_jsx(ExclamationCircleOutlined, {
                      style: {
                        color: 'rgba(247, 114, 52, 1)'
                      }
                    }),
                    okButtonProps: {
                      className: styles.ok
                    },
                    cancelButtonProps: {
                      className: styles.cancel
                    },
                    footer: /*#__PURE__*/_jsxs("div", {
                      className: styles.filterFooter,
                      children: [/*#__PURE__*/_jsx(Button, {
                        onClick: function onClick() {
                          modal.destroy();
                        },
                        children: "\u53D6\u6D88"
                      }), /*#__PURE__*/_jsx(Button, {
                        type: "primary",
                        onClick: function onClick() {
                          var _ref$current;
                          (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.form.setFieldsValue({
                            orgName: undefined,
                            orgCode: undefined,
                            address: undefined,
                            contract: undefined,
                            phone: undefined,
                            arrivalDate: undefined,
                            remark: '',
                            attachment: undefined
                          });
                          setHasStore(false);
                          setDetails([]);
                          setRenderDetails([]);
                          setRenderKey(nanoid());
                          modal.destroy();
                        },
                        children: "\u786E\u5B9A"
                      })]
                    })
                  });
                },
                beforeSelect: function beforeSelect() {
                  return new Promise(function (resolve) {
                    var _ref$current2;
                    if (!((_ref$current2 = ref.current) !== null && _ref$current2 !== void 0 && _ref$current2.form.getFieldValue('orgName'))) {
                      resolve(true);
                      setHasStore(true);
                      return;
                    }
                    var modal = Modal.confirm({
                      className: styles.modal,
                      title: "\u786E\u8BA4\u5207\u6362\u95E8\u5E97\u5417?",
                      content: /*#__PURE__*/_jsx("span", {
                        style: {
                          color: '#6E707A'
                        },
                        children: "\u5207\u6362\u540E\u586B\u5199\u7684\u4FE1\u606F\u5C06\u88AB\u6E05\u7A7A"
                      }),
                      icon: /*#__PURE__*/_jsx(ExclamationCircleOutlined, {
                        style: {
                          color: 'rgba(247, 114, 52, 1)'
                        }
                      }),
                      okButtonProps: {
                        className: styles.ok
                      },
                      cancelButtonProps: {
                        className: styles.cancel
                      },
                      footer: /*#__PURE__*/_jsxs("div", {
                        className: styles.filterFooter,
                        children: [/*#__PURE__*/_jsx(Button, {
                          onClick: function onClick() {
                            resolve(false);
                            modal.destroy();
                          },
                          children: "\u53D6\u6D88"
                        }), /*#__PURE__*/_jsx(Button, {
                          type: "primary",
                          onClick: function onClick() {
                            var _ref$current3;
                            (_ref$current3 = ref.current) === null || _ref$current3 === void 0 || _ref$current3.form.setFieldsValue({
                              orgName: undefined,
                              orgCode: undefined,
                              address: undefined,
                              contract: undefined,
                              phone: undefined,
                              arrivalDate: undefined,
                              remark: '',
                              attachment: undefined
                            });
                            setHasStore(true);
                            setRenderKey(nanoid());
                            resolve(true);
                            modal.destroy();
                          },
                          children: "\u786E\u5B9A"
                        })]
                      })
                    });
                  });
                },
                autoDictType: "shop_suggest"
              }), /*#__PURE__*/_jsx(Text, {})]
            }), /*#__PURE__*/_jsxs(Form.Field, {
              name: "contract",
              label: "\u8054\u7CFB\u4EBA",
              children: [/*#__PURE__*/_jsx(Input, {
                placeholder: "\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA",
                maxLength: 50,
                className: styles.baseFormWidth
              }), /*#__PURE__*/_jsx(Text, {})]
            }), /*#__PURE__*/_jsxs(Form.Field, {
              name: "phone",
              label: "\u624B\u673A\u53F7",
              children: [/*#__PURE__*/_jsx(Input, {
                placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7",
                maxLength: 11,
                className: styles.baseFormWidth
              }), /*#__PURE__*/_jsx(Text, {})]
            }), /*#__PURE__*/_jsxs(Form.Field, {
              name: "arrivalDate",
              label: "\u671F\u671B\u5230\u8D27\u65E5\u671F",
              children: [/*#__PURE__*/_jsx(DatePicker, {
                disabledDate: function disabledDate(current) {
                  return current && current < dayjs().endOf('day');
                },
                placeholder: "\u8BF7\u9009\u62E9\u5230\u8D27\u65E5\u671F",
                className: styles.baseFormWidth
              }), /*#__PURE__*/_jsx(Text, {})]
            }), /*#__PURE__*/_jsxs(Form.Field, {
              name: "address",
              label: "\u95E8\u5E97\u5730\u5740",
              className: data.canEdit ? undefined : styles.item60,
              children: [/*#__PURE__*/_jsx(Input, {
                maxLength: 200,
                placeholder: "\u8BF7\u8F93\u5165\u95E8\u5E97\u5730\u5740",
                className: styles.baseFormWidth
              }), /*#__PURE__*/_jsx(Text, {})]
            }), /*#__PURE__*/_jsxs(Form.Field, {
              name: "requestType",
              label: "\u91C7\u8D2D\u7533\u8BF7\u7C7B\u578B",
              className: data.canEdit ? undefined : styles.item60,
              required: true,
              rules: [{
                required: true,
                message: '请选择采购申请类型'
              }],
              children: [/*#__PURE__*/_jsx(DictSuggest, {
                placeholder: "\u8BF7\u9009\u62E9\u91C7\u8D2D\u7533\u8BF7\u7C7B\u578B",
                dictType: "scm_request_order_request_type",
                onChange: function onChange(requestType) {
                  return onSkuListQuery({
                    requestType: requestType
                  });
                }
              }), /*#__PURE__*/_jsx(DictText, {
                dictType: "scm_request_order_request_type"
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex",
            children: [/*#__PURE__*/_jsxs(Form.Field, {
              name: "remark",
              label: "\u6574\u5355\u5907\u6CE8",
              style: {
                flexBasis: '70%'
              },
              children: [/*#__PURE__*/_jsx(TextArea, {
                placeholder: "\u8BF7\u8F93\u5165\u6574\u5355\u5907\u6CE8",
                maxLength: 300,
                style: {
                  width: 720
                },
                autoSize: true
              }), /*#__PURE__*/_jsx(HtmlText, {})]
            }), /*#__PURE__*/_jsxs(Form.Field, {
              name: "businessType",
              label: "\u5355\u636E\u7C7B\u578B",
              style: {
                flexBasis: '25%'
              },
              children: [/*#__PURE__*/_jsx(DictText, {
                dictType: "scm_request_order_business_type"
              }), /*#__PURE__*/_jsx(DictText, {
                dictType: "scm_request_order_business_type"
              })]
            })]
          }), /*#__PURE__*/_jsxs(Form.Field, {
            name: "attachment",
            label: "\u9644\u4EF6",
            children: [/*#__PURE__*/_jsx(UploadWithFilename, {
              children: /*#__PURE__*/_jsxs(Button, {
                size: "middle",
                style: {
                  color: '#000000E0'
                },
                children: [/*#__PURE__*/_jsx(UploadOutlined, {
                  style: {
                    color: '#00000040'
                  }
                }), "\u70B9\u51FB\u4E0A\u4F20"]
              })
            }, renderKey), /*#__PURE__*/_jsx(UploadWithFilename, {
              disabled: true
            })]
          })]
        }), (_data$orderFlowList = data.orderFlowList) !== null && _data$orderFlowList !== void 0 && _data$orderFlowList.length ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.subTitle,
            id: "\u5173\u8054\u4EFB\u52A1",
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.labelIcon
            }), " \u5173\u8054\u4EFB\u52A1"]
          }), /*#__PURE__*/_jsx(Table, {
            style: {
              zIndex: 101
            },
            pagination: false,
            rowKey: function rowKey(record, index) {
              return "".concat(record.item, "-").concat(index);
            },
            scroll: {
              x: 'max-content'
            },
            columns: listCol,
            dataSource: data.orderFlowList
          })]
        }) : null, /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.panel,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.subTitle2,
              id: "\u5355\u636E\u660E\u7EC6",
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.labelIcon
              }), " \u5355\u636E\u660E\u7EC6"]
            }), /*#__PURE__*/_jsx(Search, {
              onReset: onResetSearch,
              onSearch: function onSearch(val) {
                return onSearchDetail(val);
              }
            }), /*#__PURE__*/_jsxs("div", {
              className: classnames(styles.tableContainer, expanded ? null : styles.unExpanded),
              children: [/*#__PURE__*/_jsx(TreeSelect, {
                onExpandChange: setExpanded,
                dataSource: category,
                value: activeCategory,
                numberMap: numberMap,
                hasStore: hasStore,
                onChange: function onChange(v) {
                  return onSelectCategory(v);
                }
              }), /*#__PURE__*/_jsx(PureTable, {
                size: "small",
                columns: detailCol,
                dataSource: renderDetails || [],
                pagination: false
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: styles.line
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.btnContainer,
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: "\u70B9\u51FB\u53EF\u83B7\u53D6\u6700\u65B0\u6570\u636E",
          children: /*#__PURE__*/_jsx(Button, {
            onClick: onRefresh,
            icon: /*#__PURE__*/_jsx(RefreshSvg, {}),
            children: "\u5237\u65B0"
          })
        }), data.orderCode ? /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(Button, {
            onClick: onExport,
            icon: /*#__PURE__*/_jsx(ExportSvg, {}),
            children: "\u5BFC\u51FA"
          })
        }) : null, data.canEdit ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Button, {
            onClick: onSave,
            icon: /*#__PURE__*/_jsx(SaveSvg, {}),
            children: "\u4FDD\u5B58"
          }), /*#__PURE__*/_jsx(Button, {
            onClick: function onClick() {
              return onSubmit('提交', 'submit');
            },
            icon: /*#__PURE__*/_jsx(AduitSvg, {}),
            type: "primary",
            children: "\u63D0\u4EA4"
          })]
        }) : null, data.canRebut ? /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return onReject('驳回', 'rebut');
          },
          icon: /*#__PURE__*/_jsx(RejectSvg, {}),
          type: "primary",
          children: "\u9A73\u56DE"
        }) : null, data.canReject ? /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return onReject('拒绝', 'reject');
          },
          icon: /*#__PURE__*/_jsx(RefuseSvg, {}),
          type: "primary",
          children: "\u62D2\u7EDD"
        }) : null, data.canAudit ? /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return onSubmit('审核', 'audit');
          },
          icon: /*#__PURE__*/_jsx(AduitSvg, {}),
          type: "primary",
          children: "\u5BA1\u6838"
        }) : null]
      })]
    })
  });
};
export default (function () {
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var orderCode = searchParams.get('orderCode');
  return /*#__PURE__*/_jsx(Detail, {}, orderCode);
});